module.exports = __webpack_public_path__ + "img/img_communication_20.28f95b16.jpg";